import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import InputBase from "@material-ui/core/InputBase";
import Typography from "@material-ui/core/Typography";
import { createMuiTheme } from "@material-ui/core/styles";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import CheckIcon from '@material-ui/icons/Check';
import { ThemeProvider } from "@material-ui/styles";

import * as actions from "../../Actions/bankfeeds";

import css from "./login.css";
import ReckonLogo from "./logo-icon.png";

class ResetPasswordForm extends React.Component {

  theme = createMuiTheme({
    palette: {
      primary: { main: "#262626" },
      secondary: { main: "#00bd9d" },
      error: { main: "#e30613"}
    },
    overrides: {
      MuiButton: {
        containedPrimary: {
          fontWeight: "bold"
        },
        containedSecondary: {
          color: "white",
          fontWeight: "bold"
        },
        containedDefault: {
          color: "white",
          fontWeight: "bold"
        }
      }
    }
  });
  
  submit = values => {
      if (values.username === undefined) {
          throw new SubmissionError({
          username: "Enter a email"
        });
      }
      this.props.resetPassword(values.username);
    };
  
    renderTextField = ({
      input,
      label,
      id,
      meta: { touched, error },
      ...custom
    }) => (
      <div className={css.pb10}>
        <MailOutlineIcon className={css.icon} />
        <TextField
          style={{ width: "80%" }}
          placeholder={label}
          {...input}
          {...custom}
        />
        <div className={css.error}>{touched && error}</div>
      </div>
    );
    

  render() {
  const { onToggle, handleSubmit, pristine, bankfeeds } = this.props;

  let buttonColor = 'secondary';
  let buttonInfo = 'Reset Password';
  if (bankfeeds.reset !== undefined) {
    if (bankfeeds.reset === true) {
      buttonInfo = `Sent!`;
    }
    if (bankfeeds.reset === false) {
      buttonInfo = 'Email not known to Reckon, try again?';
      buttonColor = 'default';
    }
  }
  if (bankfeeds.resetting) buttonInfo = <CircularProgress size={24} />;

  return (
    <React.Fragment>
      <ThemeProvider theme={this.theme}>
        <img src={ReckonLogo} className={css.avatar} />
        <Typography component="h1" variant="h5">
          Reset your password
        </Typography>
        <form className={css.form} onSubmit={handleSubmit(this.submit)}>
            <Typography align="center" color="textSecondary" variant="subtitle1" gutterBottom>
              We'll send you a link to recover your password
            </Typography>
            <Field
                component={this.renderTextField}
                margin="normal"
                id="email"
                name="username"
                label="Email"
                autoFocus
              />
            {/* {bankfeeds.error && (
              <div className={css.error}>
                {`Failed attempt, check your email and try again`}
              </div>
            )} */}
          <div className={css.pl35}>
            <div className={[css.pr30, css.pt20].join(" ")}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color={buttonColor}
                disabled={pristine || bankfeeds.resetting}
              >
                {buttonInfo}
              </Button>
              <div className={css.back} onClick={onToggle}>
                  &larr; Back to Sign In
              </div>
            </div>
          </div>
        </form>
      </ThemeProvider>
    </React.Fragment>
  );
          }
};

function mapStateToProps(state) {
  const { bankfeeds } = state;
  return { bankfeeds };
}

ResetPasswordForm = connect(mapStateToProps, actions)(
  reduxForm({
    form: 'resetPasswordForm'
  })(ResetPasswordForm)
);

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/Portal/ResetPasswordForm.js